import './index.scss';

export default function ModalItem({ isOpen, closeModal, informacoes }) {
    if (!isOpen) {
        return null;
    }

    return (
        <div className='modal-Item' onClick={closeModal}>
      
            <div className='container-item' onClick={(e) => e.stopPropagation()}>
               
                <div className='titulo'>
                    <div className='texto'>
                        <h1>Maquina rotativa xcore</h1>
                        <p>
                        Aqui você pode editar ou excluir seu produto.
                        </p>
                    </div>
                    <button><img src="./assets/images/estoque/lixo.png" alt="" /></button>
                </div>

                <form>
                    <div className='container-input'>
                        <label htmlFor=''>Nome</label>
                        <input type="text" placeholder='Maquina rotativa xcore'/>
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Url Imagem</label>
                        <input type="text" placeholder='./assets/images/estoque/maquina.png'/>
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Quantidade Disponível</label>
                        <input type="text" placeholder='1' />
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Quantidade Total</label>
                        <input type="text" placeholder='2' />
                    </div>
                </form>
                <div className='botoes'>
                <button onClick={closeModal}>Cancelar</button>
                <button onClick={closeModal}>Salvar</button>
                </div>
                
            </div>
        </div>
    );
}
